import {formatLocaleDate} from '@/dayjs'
import {AgendaAppointmentStatus} from '@/features/agenda/components/agenda-appointment-status/AgendaAppointmentStatus'
import {
    StyledAgendaScheduleTime,
    StyledAgendaScheduleTimeContainer
} from '@/features/agenda/components/agenda-schedule-time/style'
import type {AgendaEventAppointment} from '@/features/agenda/types'

interface AgendaScheduleTimeProps {
    startDate: Date
    endDate: Date
    status: AgendaEventAppointment['status']
}

export const AgendaScheduleTime = ({startDate, endDate, status}: AgendaScheduleTimeProps) => {
    return (
        <StyledAgendaScheduleTimeContainer align="center" justify="flex-start" gap={4}>
            <StyledAgendaScheduleTime>
                {formatLocaleDate(startDate, 'HH:mm')} - {formatLocaleDate(endDate, 'HH:mm')}
            </StyledAgendaScheduleTime>
            {status && <AgendaAppointmentStatus status={status} />}
        </StyledAgendaScheduleTimeContainer>
    )
}
